import React from "react";
import { Autocomplete, TextField, Box, Typography, Chip } from "@mui/material";

//Shared Styles
export const NAVY = "#142c54";
export const cardSx = {
  borderRadius: "12px",
  border: "1px solid #eef0f4",
  boxShadow: "0px 2px 8px rgba(20, 44, 84, 0.06)",
  backgroundColor: "#fff",
};
export const headCellSx = { fontWeight: 700, color: "#fff", backgroundColor: "#154c79", fontSize: 12 };

export const CURRENT_YEAR = new Date().getFullYear();

//Helpers
export const toKey = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const fromKey = (k) => new Date(`${k}T00:00:00`);
export const fmtDate = (k) =>
  k ? fromKey(k).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";
export const fmtNum = (n) =>
  n === null || n === undefined || Number.isNaN(n) ? "" : Number.isInteger(n) ? String(n) : String(parseFloat(n.toFixed(2)));

export const generateFormNo = () => String(Math.floor(Math.random() * 90000000) + 10000000);

export const getYearOptions = () => {
  const years = [];
  for (let y = CURRENT_YEAR + 1; y >= 2020; y--) years.push(y);
  return years;
};

export const dateRange = (start, end) => {
  const out = [];
  if (!start || !end) return out;
  const s = fromKey(start);
  const e = fromKey(end);
  if (isNaN(s) || isNaN(e)) return out;
  for (let d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) out.push(toKey(d));
  return out;
};

export const daysBetween = (start, end) => dateRange(start, end).length;

// Sunday is the weekly off day (Saturday is a working day)
export const isSunday = (k) => fromKey(k).getDay() === 0;

export const validateRange = (start, end, holidayDates = []) => {
  const holidays = new Set(holidayDates);
  const dates = dateRange(start, end);
  const sundays = dates.filter((d) => isSunday(d));
  const hols = dates.filter((d) => !isSunday(d) && holidays.has(d));
  if (!sundays.length && !hols.length) return "";
  const parts = [];
  if (sundays.length) parts.push(`${sundays.length} Sunday${sundays.length > 1 ? "s" : ""}`);
  if (hols.length) parts.push(`${hols.length} holiday${hols.length > 1 ? "s" : ""}`);
  return `Selected range includes ${parts.join(" and ")}: ${[...sundays, ...hols].sort().map(fmtDate).join(", ")}`;
};

export const validatePhone = (v) => {
  if (!v) return "";
  if (!/^\d+$/.test(v)) return "Contact No. must contain only numbers";
  if (v.length !== 10) return "Contact No. must contain exactly 10 numbers";
  return "";
};

export const STATUS_STYLE = {
  Pending: { color: "#b45309", bg: "#fef3c7" },
  Approved: { color: "#15803d", bg: "#dcfce7" },
  Rejected: { color: "#b91c1c", bg: "#fee2e2" },
  Cancelled: { color: "#475569", bg: "#e2e8f0" },
};

export const RequestStatusChip = ({ status }) => {
  const s = STATUS_STYLE[status] || { color: "#64748b", bg: "#f1f5f9" };
  return <Chip label={status} size="small" sx={{ fontWeight: 700, fontSize: 11, color: s.color, backgroundColor: s.bg }} />;
};

//Shared Employee Search Box
export const EmployeeSelect = ({
  value, onChange, options = [], label = "Employee",
  placeholder = "Search by name or service no...", required, error, helperText, sx,
}) => (
  <Autocomplete
    size="small"
    options={options}
    value={value}
    onChange={(e, v) => onChange(v)}
    getOptionLabel={(o) => `${o.name} (${o.serviceNo})`}
    isOptionEqualToValue={(a, b) => a.serviceNo === b.serviceNo}
    noOptionsText="No employees found"
    renderOption={(props, o) => (
      <li {...props} key={o.serviceNo}>
        <Box>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{o.name}</Typography>
          <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>{o.serviceNo} · {o.department}</Typography>
        </Box>
      </li>
    )}
    renderInput={(params) => (
      <TextField {...params} label={label} placeholder={placeholder} required={required} error={error} helperText={helperText} />
    )}
    sx={sx}
  />
);